<script setup>
import { ref, defineModel, defineProps, computed, readonly } from "vue";
import AppIcon from "./AppIcon.vue";

const model = defineModel();
const props = defineProps({
  apps: Array,
  title: String,
  description: String,
  readOnlyMode: Boolean,
});
const selected = ref([]);
const showSelect = ref(false);
const searchField = ref("");

const headers = [
  { title: "App Name", value: "name", sortable: true },
  { title: "Architecture", value: "stream", sortable: true },
  {
    title: "Latest Version",
    value: "latestApprovedPatch.version",
    sortable: true,
  },
  {
    title: "Release Date",
    value: "latestApprovedPatch.approvedAt",
    sortable: true,
  },
];

const appsShown = computed(() => {
  let result = [];
  console.log("MODEL", model);
  console.log("showSelect", showSelect.value);
  if (showSelect.value) {
    result.push(...props.apps);
  } else {
    model.value.forEach((app) => {
      let match = props.apps.find(
        (a) => a.id == app.id && a.stream == app.stream
      );
      if (match) {
        result.push(match);
      }
    });
  }

  console.log("Result", result);
  return result;
});

function enterEditMode() {
  selected.value.length = 0;
  model.value.forEach((app) => {
    let match = props.apps.find(
      (a) => a.id == app.id && a.stream == app.stream
    );
    if (match) {
      selected.value.push(match._id);
    }
  });
  showSelect.value = true;
}

function exitEditMode() {
  let result = [];
  selected.value.forEach((selected) => {
    console.log("Selected", selected);
    let match = props.apps.find((a) => a._id == selected);
    if (match) {
      result.push({ id: match.id, stream: match.stream });
    }
  });
  model.value = result;
  showSelect.value = false;
}

function imageURL(appID) {
  var result = "";
  if (appID) {
    result = "https://patch24content.j24.io/" + appID + ".png";
  }
  return result;
}
</script>

<template>
  <v-row>
    <v-col cols="auto" align-self="center">
      <div class="font-weight-bold" v-if="props.title">{{ props.title }}</div>
      <div
        v-if="props.description"
        class="text-body-2 font-weight-light text-medium-emphasis"
      >
        {{ props.description }}
      </div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="3">
      <v-text-field
        v-model="searchField"
        hide-details
        density="compact"
        variant="outlined"
        placeholder="Search..."
        clearable
      ></v-text-field>
    </v-col>
    <v-col v-if="!props.readOnlyMode" cols="auto">
      <v-btn
        prepend-icon="mdi-pencil"
        class=""
        color="primary"
        @click="enterEditMode()"
        v-if="!showSelect"
        >Add/Remove Apps</v-btn
      >
      <v-btn color="primary" @click="exitEditMode()" v-if="showSelect"
        >Save</v-btn
      >
    </v-col>
    <v-col cols="auto" v-if="showSelect">
      <v-btn @click="showSelect = false">Cancel</v-btn>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="appsShown"
        :show-select="showSelect"
        item-value="_id"
        :search="searchField"
        no-data-text="No Applications Selected"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-row align="center">
            <v-col cols="auto">
              <AppIcon :appID="item.id" />
            </v-col>
            <v-col cols="auto">
              {{ item.name }}
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.latestApprovedPatch.approvedAt`]="{ value }">
          {{ new Date(value).toLocaleDateString() }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
